<div class="tablecontainer container my-2">
  <div class="row">
    <div class="col-12 ">
      <span class="title_header_bar">Manage Suspension</span>
    </div>
  </div>
  <div class="card card_content">
    <div class="row" style="margin-bottom: 2rem;">
      <div class="col-6 d-flex justify-content-start align-items-center gap-3">
        <button class="btn btn-primary" (click)="navigateToSuspension()">
          <svg viewBox="0 0 24 24">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
          New Suspension Schedule
        </button>
        <div class="ml-3">
          <app-button (refreshClicked)="refresh()"></app-button>
        </div>
      </div>

      <div class="col-6 d-flex justify-content-end align-items-center gap-3">
        <div class="dropdown">
          <button class="btn btn-primary dropdown-toggle" type="button" (click)="toggleDropdown()">
            <span class="thin uppercase hidden-xs">{{ selectedMonthLabel }}</span>
          </button>
          <ul class="dropdown-menu dateranges pull-right" [class.show]="dropdownOpen" *ngIf="dropdownOpen"
            (click)="$event.stopPropagation()">
            <li (click)="onMonthChange('Current'); $event.preventDefault(); $event.stopPropagation()">
              <a href="javascript:void(0);">Current Month</a>
            </li>
            <li (click)="onMonthChange('Next'); $event.preventDefault(); $event.stopPropagation()">
              <a href="javascript:void(0);">Next Month</a>
            </li>
            <li (click)="onMonthChange('Custom'); $event.preventDefault(); $event.stopPropagation()">
              <a href="javascript:void(0);">Custom</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="stats-grid">
      <div class="sc">
        <div class="sc-top">
          <div class="sc-icon ic-purple"><svg viewBox="0 0 24 24">
              <rect x="3" y="4" width="18" height="18" rx="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8" y1="2" x2="8" y2="6" />
              <line x1="3" y1="10" x2="21" y2="10" />
            </svg></div>
        </div>
        <div class="sc-num num-purple">{{dashboardCount?.upComingScheduledCount}}</div>
        <div class="sc-lbl">Upcoming Suspension Schedules</div>
        <div class="sc-sub">Scheduled Suspensions</div>
      </div>

      <div class="sc">
        <div class="sc-top">
          <div class="sc-icon ic-green">
            <svg viewBox="0 0 24 24">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
            </svg>
          </div>
          <!-- <div class="sc-trend tr-up">↑ {{dashboardCount?.successNotificationCountPercentage}}</div> -->
        </div>
        <div class="sc-num num-green">{{dashboardCount?.successNotificationCount}}</div>
        <div class="sc-lbl">Pre-Notifications Count</div>
        <div class="sc-sub">Pre-Notifications Sent Successfully</div>
      </div>

      <div class="sc">
        <div class="sc-top">
          <div class="sc-icon ic-purple">
            <svg viewBox="0 0 24 24">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
        </div>
        <div class="sc-num num-purple">{{dashboardCount?.suspensionCount}}</div>
        <div class="sc-lbl">Suspensions Count</div>
        <div class="sc-sub">Suspensions Completed Successfully</div>
      </div>
    </div>

    <div class="section-bar">
      <div class="section-title">
        Upcoming Suspension Schedules for {{ monthNameString }} month
      </div>
      <div class="sync-time">
        Money Works Last Sync up at:
        <strong class="moneyWorksTime">{{ dashboardCount?.moneyWorksLastSyncTime ?
          (dashboardCount.moneyWorksLastSyncTime | date:'dd/MM/yyyy HH:mm:ss') : 'Not available' }}</strong>
      </div>
    </div>

    <div class="card" style="padding:0;overflow:hidden">
      <mat-table [dataSource]="dataSource" class="upcoming-table">


        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef>Process Type</mat-header-cell>
          <mat-cell *matCellDef="let s" [ngStyle]="getTypeStyles(s.processTypeDesc)" style="font-weight:600">
            {{ s.processTypeDesc }}
          </mat-cell> </ng-container>

        <ng-container matColumnDef="dorder">
          <mat-header-cell *matHeaderCellDef>Debit Order</mat-header-cell>
          <mat-cell *matCellDef="let s"><span class="tag">{{s.debitDateTypeDesc}} - {{s.targetMonth |
              date:'MMMM'}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="execDate">
          <mat-header-cell *matHeaderCellDef>Execution Date</mat-header-cell>
          <mat-cell *matCellDef="let s" style="text-align: center;">
            <b> <span class="badge">{{s.suspensionDate | date | date:'dd/MM/yyyy'}}</span> </b>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="scheduledBy">
          <mat-header-cell *matHeaderCellDef>Scheduled By</mat-header-cell>
          <mat-cell *matCellDef="let s">
            <span class="badge">{{s.creationUserId}}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="startedBy">
          <mat-header-cell *matHeaderCellDef>Started By</mat-header-cell>
          <mat-cell *matCellDef="let s">
            <span class="badge">{{s.startedBy}}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let s">
            <span class="badge" [ngClass]="getStatusClass(s.processStatusTypeDesc)">
              {{ s.processStatusTypeDesc }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let s">
            <div class="row-actions" style="gap:10px">

              <!-- Start Icon -->
              <a title="Start Schedule" (click)="onStart(s)" *ngIf="s.startFlag">
                <i class="fa-solid fa-play fa-lg" style="cursor: pointer; color: green;"></i>
              </a>

              <!-- Edit Icon -->
              <a title="Edit Schedule" (click)="EditData(s)" *ngIf="s.processStatusType == 1 && !s.startFlag">
                <i class="fa-regular fa-pen-to-square fa-lg" style="cursor: pointer;"></i>
              </a>

              <!-- View Icon -->
              <a title="View Schedule" (click)="ViewData(s)" *ngIf="!isDisabled(s.preNotificationDate) ">
                <i class="fa fa-eye fa-lg " style="cursor: pointer;"></i>
              </a>

              <!-- Upload Icon -->
              <i style="cursor: pointer;font-size: 18px; color: #1a66ff;" class="fa fa-upload"
                title="Upload Suspension Excel File" (click)="OpenDialog('suspension', s.manageSuspensionId)"
                *ngIf="s.isMailSent == true && s.processStatusType == 11"></i>

              <!-- Delete Icon -->
              <a title="Delete Schedule" (click)="deleteData(s.manageSuspensionId)"
                *ngIf="s.processStatusType == 1 && !s.startFlag">
                <i class="fa fa-trash fa-lg" aria-hidden="true" style="cursor: pointer;"></i>
              </a>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>

      <div *ngIf="dataSource.data.length === 0" class="p-4 text-center text-muted">
        No Upcoming Suspension Schedules found
      </div>

      <div class="d-flex">
        <div class="col-6" style="padding:12px 20px;font-size:12px;color:#aaa;border-top:.5px solid #f0eaff;
        display: flex; justify-content: space-between; align-items: center;">
          <div>
            Showing <span>{{dataSource.data.length}}</span> of <span>{{totalRecords}}</span> records
          </div>
        </div>
        <div class="col-6 table_pagenation d-flex justify-content-end"
          style="padding:12px 20px;font-size:12px;color:#aaa;border-top:.5px solid #f0eaff;">
          <mat-paginator #paginator [length]="totalRecords" [pageIndex]="pageNumber - 1" *ngIf="totalRecords>0"
            [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]" (page)="onPageChange($event)">
          </mat-paginator>
        </div>
      </div>
    </div>
    <app-suspension-process-history></app-suspension-process-history>
  </div>
</div>